import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isDrawerOpen: false,
  showSignUp: false
}

const slice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleDrawer: (state): void => {
      state.isDrawerOpen = !state.isDrawerOpen
    },
    setShowSignUp: (state, action): void => {
      state.showSignUp = action.payload
    }
  },
  extraReducers: (builder) => {
  },
})

export const { toggleDrawer, setShowSignUp } = slice.actions

export default slice.reducer
